import {useEffect} from "react";
import {useForm, Controller} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {Button, Loading} from "~/components";
import {DateField} from "~/components/Forms";
import {numberFormat} from "~/utils";

function MarketingProjectFormReactivate({item, onHandleSubmit}) {

	const initialValues = {
		endDate: '',
	}

	const validationSchema = Yup.object().shape({
		endDate: Yup.string().required('Bạn chưa chọn thời gian kết thúc'),
	});

	const {control, handleSubmit, formState: {isSubmitting, errors}, reset} = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	useEffect(() => {
		reset(initialValues);
	}, [item]);

	const onSubmit = async (data) => {
		await onHandleSubmit(data, item);
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			<p className="heading">Kích hoạt lại dự án — {item?.name}</p>
			<p style={{color: '#888', fontSize: '13px', marginBottom: 12}}>
				Ngân sách còn lại hiện tại: <b style={{color: 'var(--primary)'}}>{numberFormat(item?.budgetRemaining || 0)}đ</b> sẽ tiếp tục được sử dụng.
				Đưa dự án về trạng thái <b>Đang thực hiện</b> và đặt thời gian kết thúc mới.
			</p>
			<Controller control={control} name="endDate" render={({field}) => (
				<DateField label="Thời gian kết thúc mới" errors={errors} {...field}/>
			)}/>
			<div className="form-group d-flex justify-content-end modal-bottom">
				<Button primary type="submit">Kích hoạt lại</Button>
			</div>
		</form>
	)
}

export default MarketingProjectFormReactivate;
